module.exports = __webpack_public_path__ + "static/herencia-cd386e0199bc82fa2834bcc7f15bcd43.jpg";